import React from 'react';
import './style.css';
import novosPontos from '../../../assets/img/novos-pontos.svg';
import { useLoader } from '../../../hooks/useLoader';
import { loginLecupon } from '../../../actions/assistamais/api';
import { toast } from 'react-toastify';



const ListaManutencaoHorizontalUsemais = () => {
    
    const loader = useLoader();

    async function acessoLecupon() {
        try {
            loader.show(["Aguarde..."])

            const response = await loginLecupon();

            if (response?.payload?.status === 200) {
                window.open(response?.payload?.data?.url, "_blank");
            } else if (response?.payload?.status === 412) {
                toast.error(response?.payload?.data?.message, {
                autoClose: 3000,
                theme: 'colored',
                onClick: () => history.push('/editarperfil'),
                onClose: () => history.push('/editarperfil'),
                })
            } else {
                throw new Error(response?.payload?.data?.message ?? "Ocorreu um erro. Tente novamente mais tarde.");
            }
        } catch (e) {
            console.error(e)
            toast.error(e.message ?? "Ocorreu um erro. Tente novamente mais tarde.", {autoClose: 3000, theme: 'colored'});
        } finally {
            loader.hide()
        }
    }


    return (
        <div class="flex flex-col w-full px-4 py-8">

            <div className="w-11/12 md:w-full mx-auto text-center text-black text-[16px] md:text-[18px] lg:text-2xl font-semibold manutencao-pre-title">
                <span>Assista os anúncios, acumule pontos e troque por gift cards em</span>
                <span className="text-[#ED636E]"> diversos parceiros.</span>
            </div>

            <div class="flex flex-col sm:flex-row items-center w-[90%] mx-auto self-stretch md:shadow-lg rounded-[48px] max-md:px-5 max-md:max-w-full sm:max-h-[800px] sm:min-h-[350px]">
                <div class="w-full sm:w-1/3 flex justify-center items-center">
                    <img
                        src={novosPontos}
                        alt="em_manutencao"
                        class="h-[100%] object-contain"
                    />
                </div>

                <div class="w-full sm:w-2/3 p-6 sm:p-10 text-center sm:text-left">
                    <h2 class="text-xl sm:text-2xl font-bold text-orange-500 mb-4 leading-9 manutencao-title">
                        Seu jeito de acumular e trocar pontos vai mudar
                    </h2>
                    <p class="text-gray-700 text-sm sm:text-base leading-8 mb-2 manutencao-messages">
                        No momento, estamos trabalhando para tornar nossa seção de pontos ainda melhor!
                    </p>
                    <p class="text-gray-700 text-sm sm:text-base leading-8 mb-2 manutencao-messages">
                        Mas não se preocupe, você ainda poderá utilizar seus pontos e trocar por gifts :)
                    </p>
                    <p class="text-gray-700 text-sm sm:text-base leading-8 manutencao-messages">
                        E você ainda continua tendo acesso aos nossos benefícios do
                        <span class="text-pink-600 font-semibold cursor-pointer hover:opacity-80" onClick={()=>acessoLecupon()}> Clube Use Mais!</span>
                    </p>
                </div>
            </div>
        </div>


    );
};


export default ListaManutencaoHorizontalUsemais;